
import store from "../store";
import { PRINT_PAGE } from "../store/data/actionTypes";
import { viewLoading } from "./loading";


export const setPrint = (print) => {
  store.dispatch({
    type: PRINT_PAGE,
    payload: print
  });
  viewLoading(true)
  setTimeout(() => {
    viewLoading(false)
    window.print()
    setTimeout(() => {
      store.dispatch({
        type: PRINT_PAGE,
        payload: ''
      });
    }, 5000)
  }, 1000)
};
